import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'
import { latLngToPoint, pointToMapData } from '@/utils/forms/point-helper'
import GeoJSON from 'geojson'
import FieldMap from '@/components/field-view-next/mapbox/FieldMap.vue'
import SinglePointPin from '@/components/field-view-next/layers/SinglePointPin.vue'
import VsTextInput from '@/components/vision/Inputs/VsTextInput.vue'
import VsHeading from '@/components/vision/VsHeading.vue'
import VsButton from '@/components/vision/VsButton.vue'
import VsWrapper from '@/components/vision/VsWrapper.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'OnTheFlyLocationCoordinatesField',
  props: {
    showCoordinatesField: { type: [Boolean, null] },
    isInMapView: { type: [Boolean, null] },
    mapCenterPoint: null,
    latitude: null,
    longitude: null
  },
  setup(__props: any, { expose }) {

const props = __props as {
  showCoordinatesField?: boolean | null
  isInMapView?: boolean | null
  mapCenterPoint:
    | {
        latitude: number
        longitude: number
        zoom: number
      }
    | undefined
  latitude?: number | null
  longitude?: number | null
}

const latitudeRules = [
  (v: string) =>
    (parseFloat(v) < -90 || parseFloat(v) > 90) &&
    'Latitude must be between -90 and 90',
]
const longitudeRules = [
  (v: string) =>
    (parseFloat(v) < -180 || parseFloat(v) > 180) &&
    'Longitude must be between -180 and 180',
]


const coordinatesMiniMap = ref()

const initialCoordinatesMiniMapCenterPoint = computed(() => ({
  lat: props.mapCenterPoint?.latitude ?? 0,
  lng: props.mapCenterPoint?.longitude ?? 0,
}))
const latLonGeoJSONFormat = computed<
  GeoJSON.FeatureCollection<GeoJSON.Geometry>
>(() => {
  if (
    props.latitude !== undefined &&
    props.latitude !== null &&
    props.longitude !== undefined &&
    props.longitude !== null
  ) {
    return pointToMapData(
      latLngToPoint({
        lat: props.latitude,
        lng: props.longitude,
      })
    )
  }
  return pointToMapData(
    latLngToPoint({
      lat: 0,
      lng: 0,
    })
  )
})

const jumpMinimapTo = (coordinates: {
  latitude: number
  longitude: number
}) => {
  coordinatesMiniMap.value.map.jumpTo({
    center: { lat: coordinates.latitude ?? 0, lng: coordinates.longitude ?? 0 },
  })
}

expose({ jumpMinimapTo })

return { __sfc: true,latitudeRules, longitudeRules, props, coordinatesMiniMap, initialCoordinatesMiniMapCenterPoint, latLonGeoJSONFormat, jumpMinimapTo, FieldMap, SinglePointPin, VsTextInput, VsHeading, VsButton, VsWrapper }
}

})